// extracted by mini-css-extract-plugin
module.exports = {"modalAppIcon":"appmodalheromobile_modalAppIcon___fhuN"};